<template>
  <div class="qr-bar__logo-avatar">
    <v-img
      :src="logoSrcForDisplay"
      contain
      alt=""
      @error="fallbackLogo"
    />
  </div>
</template>

<script>
import Help from "@/utils/helper";

/**
 * Store logo in QR scan app bars — same URL rules as the staff app (`Help.img`, receipts, settings).
 * - Omit `filename` (undefined): read `localStorage.scan_store_logo` (cart / receipt).
 * - Pass `null`: menu page before store is loaded — default square logo.
 * - Pass string: from `store.logo` when store is known (filename or full URL).
 */
const LS_KEY = "scan_store_logo";

export default {
  name: "ScanQrBarLogo",
  props: {
    filename: {
      validator: (v) => v === undefined || v === null || typeof v === "string",
      default: undefined,
    },
  },
  data() {
    return {
      logoFallback: false,
    };
  },
  computed: {
    resolvedFile() {
      if (this.filename === undefined) {
        try {
          return localStorage.getItem(LS_KEY) || "";
        } catch {
          return "";
        }
      }
      if (this.filename === null) {
        return "";
      }
      return this.filename;
    },
    logoSrcForDisplay() {
      if (this.logoFallback) {
        return Help.img(null);
      }
      const fn = String(this.resolvedFile || "").trim();
      if (!fn) {
        return Help.img(null);
      }
      return Help.img(fn) || Help.img(null);
    },
  },
  watch: {
    resolvedFile() {
      this.logoFallback = false;
    },
  },
  methods: {
    fallbackLogo() {
      this.logoFallback = true;
    },
  },
};
</script>
